import { create } from 'zustand';

export interface ISearchFlowLayoutStore {
	currentSnapIndex: number;
	setSnapIndex: (index: number) => void;
	reset: () => void;
}

const initialState: Omit<ISearchFlowLayoutStore, 'setSnapIndex' | 'reset'> = {
	currentSnapIndex: 0,
};

export const useSearchFlowLayoutStore = create<ISearchFlowLayoutStore>(
	(set) => ({
		...initialState,
		setSnapIndex: (index) => set({ currentSnapIndex: index }),
		reset: () => set(initialState),
	})
);
